import { AttendeeHandler } from '@helpers/attendee';
import { useRosterState } from '@providers/RosterProvider';
import { useEffect } from 'react';

const attendeeHandler = new AttendeeHandler();

export function useAttendee() {
  const { roster } = useRosterState();

  useEffect(() => {
    attendeeHandler.printRoster(roster);
  }, [roster]);
}
